export default {
  // Inhalt des Modals
  model: {
    id: 0,
    name: '',

    forced: true
  },

  name: 'denominations',

  validate () {
    return this.model.name.trim() !== ''
  },

	validateModel () {
		return true
	},

	copy (aModel) {
    this.model.id = aModel.id
    this.model.name = aModel.name

    this.model.forced = true
  },

  // Die Spalten für die Tabelle
  cols: [
    {
      name: 'Bezeichnung',
      json: 'name',
      type: 'text'
    }
  ],

  clear () {
    this.model.id = 0
    this.model.name = ''
    this.model.forced = true
  }
}



// WEBPACK FOOTER //
// ./src/models/denominations.js